module.exports = {
  DASHBOARD: '/dashboard',
  AD: {
    LIST: '/ad',
    DETAILS: '/ad/details/:id',
    CREATE: '/ad/create',
    UPDATE: '/ad/update/:id',
  },
  COMMANDS: {
    LIST: '/commands',
  },
  CREDIT: {
    LIST: '/credit',
  },
  CURRENCY_FILTER: {
    LIST: '/currency-filter',
    CREATE: '/currency-filter/create',
    UPDATE: '/currency-filter/update/:id',
  },
  EXCHANGE_RATE: {
    LIST: '/exchange_rate',
    CREATE: '/exchange_rate/create',
    UPDATE: '/exchange_rate/update/:id',
    DETAILS: '/exchange_rate/details/:id',
  },
  EXPIRED_AD: {
    LIST: '/expired_ad',
    DETAILS: '/expired_ad/details/:id',
  },
  FLAGGED_ADS: {
    LIST: '/flagged_ad',
    DETAILS: '/flagged_ad/details/:id',
  },
  PAID_AD: {
    LIST: '/paidad',
    CREATE: '/paidad/create',
    UPDATE: '/paidad/update/:id',
    DETAILS: '/paidad/details/:id',
    REPORT: {
      LIST: '/paidad/report',
      DETAILS: '/paidad/report/details/:id',
    },
    REVIEW: {
      LIST: '/paidad/review',
    },
  },
  PAYMENT: {
    LIST: '/payment',
    DETAILS: '/payment/details/:id',
  },
  PERMISSION: {
    LIST: '/permission',
    CREATE: '/permission/create',
    UPDATE: '/permission/update/:id',
    DETAILS: '/permission/details/:id',
  },
  PROCESSOR_RULE: {
    LIST: '/processor_rule',
    CREATE: '/processor_rule/create',
    UPDATE: '/processor_rule/update/:id',
    DETAILS: '/processor_rule/details/:id',
  },
  REVIEW_PROCESSOR_RULE: {
    LIST: '/review_processor_rule',
    CREATE: '/review_processor_rule/create',
    UPDATE: '/review_processor_rule/update/:id',
    DETAILS: '/review_processor_rule/details/:id',
  },
  REVIEW_PROCESSOR_LIST: {
    LIST: '/review_processor_list',
    CREATE: '/review_processor_list/create',
    UPDATE: '/review_processor_list/update/:id',
    DETAILS: '/review_processor_list/details/:id',
  },
  RADAR: {
    LIST: '/radar',
    CREATE: '/radar/create',
    UPDATE: '/radar/update/:id',
    DETAILS: '/radar/details/:id',
  },
  REVIEW_QUEUE: {
    LIST: '/review_queue',
  },
  REVIEW_REPORT: {
    LIST: '/review_reports',
    DETAILS: '/review_reports/details/:id',
  },
  REVIEWS: {
    LIST: '/reviews',
    DETAILS: '/reviews/details/:id',
  },
  REVIEW_RULES: {
    DETAILS: '/review_rules/:rule/:id',
  },
  USER: {
    LOGIN: '/user/login',
    LIST: '/user',
    CREATE: '/user/create/:userType/:agencyId?',
    UPDATE: '/user/update/:id',
    CHANGE_PASSWORD: '/user/change_password',
    PERMISSION: '/user/permission/:id',
    DETAILS: '/user/details/:id/',
  },
  AGENCY: {
    LIST: '/agency',
  },
  PROMOTED_AD: {
    LIST: '/promotedad',
    CREATE: '/promotedad/create',
    UPDATE: '/promotedad/update/:id',
    DETAILS: '/promotedad/details/:id',
    REPORT: {
      LIST: '/promotedad/report',
      DETAILS: '/promotedad/report/details/:id',
    },
    REVIEW: {
      LIST: '/promotedad/review',
    },
  },
  PROMOTED_AD_PACKAGES: {
    LIST: '/packages',
    CREATE: '/packages/create',
  },
  CREDIT_BUNDLE: {
    LIST: '/credit_bundle',
    CREATE: '/credit_bundle/create',
    REPORT: '/credit_bundle/report/:id',
  },
  SEND_EMAIL: {
    FORM: '/send_email',
  },
  SEND_PUSH_NOTIFICATION: {
    FORM: '/send_push_notification',
  },
  NOTIFICATION_CATEGORY: {
    LIST: '/notification_category',
    CREATE: '/notification_category/create',
    UPDATE: '/notification_category/update/:id',
  },
  NOTIFICATION_TYPE: {
    LIST: '/notification_type',
    CREATE: '/notification_type/create',
    UPDATE: '/notification_type/update/:id',
    DETAILS: '/notification_type/details/:id',
  },
};
